// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import type { OperationComponent } from "react-apollo";

export const azureAuthMutation = gql`
  mutation {
    azureAuth {
      token
    }
  }
`;

export type azureAuthMutationResult = {
  data: {
    azureAuth: {
      token: string
    }
  }
};

export const withAzureAuth: OperationComponent<
  azureAuthMutationResult
> = graphql(azureAuthMutation, {
  name: "azureAuth"
});

export type withAzureAuthType = () => Promise<azureAuthMutationResult>;



// WEBPACK FOOTER //
// ./src/data/azure.js